export const FAVORITES_LIST_LIMIT = 499

export const MINUTE_MILLISECONDS = 60000
export const TIMEOUT_1500 = 1500

export const TAB_WIDTH = 768
export const DESKTOP_WIDTH = 1280
export const ROW_COLUMN_MIN_WIDTH = 1025
export const ROW_COLUMN_WIDTH = 1024
export const MIN_WIDTH_CLOSEICON = 639
export const MAX_WIDTH_MOBILE = 374
export const MAX_MID_WIDTH = 1600

export const DEFAULT_NEWSLETTER_POPUP_TRIGGER_TIME = 9
export const DEFAULT_PRODUCT_COUNT_PLP = 30
export const DEFAULT_TECHNICAL_SPECT_COUNT = 30
export const TECHNICAL_SPECT_SEARCH_COUNT = 5

export const POST_ORDER_NO_OF_DAYS = 45
export const MIN_DELAY = 100
export const TOAST_MESSAGE_DEFAULT_DURATION = 5000
export const STORE_MIN_DISTANCE = 64
export const STORE_MAX_DISTANCE = 1000
export const LOCATION_API_TRIGGER_INTERVAL = 1800000
export const TotalSecsForaDay = 86400000
export const TOTAL_SECONDS_FOR_A_DAY = TotalSecsForaDay

export const MILLISECONDSADAY = 86400000
export const debounceThresholdCheckUserExists = 500

export const DEFAULT_SCROLL = {
  scroll: 60,
  backToTop: 20,
  freeQuote: 120,
  findAPro: 120,
  installationServices: 120,
}

// Backward compatible aliases.
export const postOrderNoOfDays = POST_ORDER_NO_OF_DAYS
export const DEFAULT_NEWELETTER_POPUP_TRIGGER_TIME =
  DEFAULT_NEWSLETTER_POPUP_TRIGGER_TIME
